module.exports = __webpack_public_path__ + "a0968f2c58de9457f50aeecdb69049ee.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gorgutz-panel-1024.webp
// module id = 370
// module chunks = 0